<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品生产组码管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleGo(1,'')">
            <i class="iconfont icon-xinzeng"></i> 添加商品生产计划
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入商品生产组码查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.ercode" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      商品名称：<span>{{ item.cmidstr }}</span>
                    </p>
                    <p>
                      商品SKU编码：<span>{{ item.sku }}</span>
                    </p>
                    <p>
                      属性标签&属性标签值：<span>{{ item.attrname }}</span> <span>{{ item.attrvalue }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      生产商：<span>{{ item.productidstr }}</span>
                    </p>
                    <p>
                      生产批次：<span>{{ item.productno }}</span>
                    </p>
                    <p>
                      投产时间：<span>{{ item.startdate | formatDate }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      预期生产数量：<span>{{ item.plannum }}</span>
                    </p>
                    <p>
                      初始货码：<span>{{ item.biancode }}</span>
                    </p>
                    <p>
                      创建日期：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="btn_group row-colc">
                <div class="editBtn" @click="handleGo(1,item.id)">
                  编辑商品生产→
                </div>
                <div class="editBtn" @click="handleGo(2,item.id)">
                  货码管理→
                </div>
              </div>
            </div>
          </div>
        </template>

        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getShopProductionCode } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cProductionCode",
  data() {
    return {
      loading: false,
      searchTxt: "",
      params: {
        pageindex: 1,
        pagesize: 20,
        keyword: "",
        cmid: "",
      },
      listTotal: 0,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.cmid = id;
        this.getShopProductionCode();
      } else {
        this.$router.back();
      }
    },

    getShopProductionCode() {
      this.loading = true;
      getShopProductionCode(this.params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    handleSearch() {
      this.getShopProductionCode();
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getShopProductionCode();
    },

    handleReturn() {
      history.back();
    },

    handleEdit(id) {
      let { cmId, cmSku } = this.$route.params;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cShopAttachmentSet",
        query: { id, cmId, cmSku },
      });
    },
    handleAdd() {
      let { cmId, cmSku } = this.$route.params;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cShopAttachmentSet",
        query: { cmId, cmSku },
      });
    },
    handleGo(type, id) {
       let {cmid} = this.params
      if (type == 1) {
        if (id) {
          this.encryptstringadd("cProductionCodeSet", { id, cmid });
          // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
        } else {
          this.encryptstringadd("cProductionCodeSet", {id: '', cmid});
        }
      } else {
        this.encryptstringadd("cProductionCodeDetail", { id, cmid });
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .list_wrap {
    height: 57vh;
    .item_main_wrap {
      align-items: center;
      .icon-zanwutupian1 {
        font-size: 40px;
      }
      .pic_box {
        width: 80px;
        height: 80px;
      }
      .btn_group {
        .editBtn {
          &:last-child {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>